import { useState } from "react";
import { useNavigate } from "react-router-dom";
import ReCAPTCHA from "react-google-recaptcha";

import ValidatedPws from "../../components/ValidatedInput/ValidatedPws/ValidatedPws";
import ButtonFotter from "../../components/Button/ButtonFotter/ButtonFotter";
import ValidatedInput from "../../components/ValidatedInput/ValidatedInput";
import Typography from "../../components/Typography/Typography";
import Loader from "../../components/Loader/Loader";
import Switch from "../../components/Switch/Switch";
import LoginImg from "../../assets/loginImage.svg";
import AuthPageShell from "../../components/AuthPageShell/AuthPageShell";
import shellStyles from "../../components/AuthPageShell/AuthPageShell.module.scss";
import styles from "./Login.module.scss";
import codes from "../../utils/codes";
import { getEmbedParentOrigin, isEmbedMode } from "../../utils/embed";

import { ReactComponent as ArrowLeft } from "../../assets/arrowLeft.svg";
import { loginUser } from "../../utils/services";

const LOGIN_SUCCESS = window.env.REACT_APP_LOGIN_URL;
const RECAPTCHA_KEY = window.env.REACT_APP_GOOGLE_KEY;

const VTEX_STATE_KEY = "jv_vtex_oauth_state";
const VTEX_CALLBACK_DEFAULT =
	"https://vtexid.vtex.com.br/VtexIdAuthSiteKnockout/ReceiveAuthorizationCode.ashx";

const Login = () => {
	const navigate = useNavigate();

	const [username, setUsername] = useState();
	const [usernameError, setUsernameError] = useState();
	const [usernameErrorMjs, setUsernameErrorMjs] = useState();

	const [pws, setPws] = useState();
	const [passwordError, setPasswordError] = useState();
	const [passwordErrorMjs, setPasswordErrorMjs] = useState();

	const [error, setError] = useState(false);

	const [keepLoggedIn, setKeepLoggedIn] = useState(false);

	const [token, setToken] = useState(null);
	const [captchaError, setCaptchaError] = useState(false);

	const [loader, setLoader] = useState(false);

	const handleBackClick = () => {
		navigate("/");
	};

	const handleBtnDisabled = () => {
		if (username && pws && token) return false;
		else return true;
	};

	const handleLogin = () => {
		if (!username) {
			setUsernameError(true);
			setUsernameErrorMjs("Campo inválido");
			return;
		}

		if (!pws) {
			setPasswordError(true);
			setPasswordErrorMjs("Campo inválido");
			return;
		}

		if (!token) {
			setCaptchaError(true);
			return;
		}

		setLoader(true);

		const vtexOAuthState = sessionStorage.getItem(VTEX_STATE_KEY);
		const rData = {
			email: username,
			password: pws,
			captchaToken: token,
			keepLogin: keepLoggedIn,
		};
		if (vtexOAuthState) {
			rData.vtexOAuthState = vtexOAuthState;
		}

		loginUser({ formInfo: rData })
			.then(({ message, code }) => {
				if (code === codes.JVB001.code) {
					const storedState = sessionStorage.getItem(VTEX_STATE_KEY);
					const isVtexFlow =
						message.vtexOAuthFlow === true ||
						(storedState != null && storedState.length > 0);

					if (isVtexFlow && storedState) {
						const callbackBase =
							window.env.REACT_APP_VTEX_OAUTH_CALLBACK_URL ||
							VTEX_CALLBACK_DEFAULT;
						const authCode = message.getAccessToken.access_token;
						const qs = new URLSearchParams({
							code: authCode,
							state: storedState,
						}).toString();
						sessionStorage.removeItem(VTEX_STATE_KEY);
						sessionStorage.removeItem("jv_vtex_oauth_client_id");
						sessionStorage.removeItem("jv_vtex_oauth_redirect_uri");
						window.location.replace(`${callbackBase}?${qs}`);
						return;
					}

					if (isEmbedMode()) {
						const parentOrigin = getEmbedParentOrigin();
						if (parentOrigin && window.parent) {
							window.parent.postMessage(
								{
									type: "JV_AUTH_SUCCESS",
									accessToken: message.getAccessToken.access_token,
									expiresIn: message.getAccessToken.expires_in,
									email: username,
									keepLogin: keepLoggedIn,
								},
								parentOrigin
							);
							return;
						}
					}

					const loginUrl = LOGIN_SUCCESS.replace(
						"{CODE}",
						message.getAccessToken.access_token
					);

					navigate(loginUrl);
				} else {
					setError(true);
				}
				setLoader(false);
			})
			.catch((e) => setLoader(false));
	};

	return (
		<>
			<AuthPageShell
				footer={
					<ButtonFotter
						onClick={handleLogin}
						disabled={handleBtnDisabled()}
						dock="panel"
					>
						Iniciar sesión
					</ButtonFotter>
				}
			>
				<div className={shellStyles.authTitleContainer}>
					<ArrowLeft
						className={shellStyles.authTitleArrow}
						onClick={handleBackClick}
					></ArrowLeft>

					<div className={shellStyles.authTitleTxt}>
						<Typography variant="h5">Iniciar Sesión</Typography>
					</div>
				</div>

				<div className={styles.loginCard}>
					<div className={styles.loginCardBrand}>
						<img
							src={LoginImg}
							alt="Amigos Juan Valdez"
							className={styles.loginCardBrandImg}
						/>
					</div>

					<div className={styles.loginCardContent}>
						<ValidatedInput
							className={styles.loginTextInput}
							label="Correo electrónico o número de identificación"
							placeholder="Escribe aquí tu correo o número de identificación"
							type="text"
							onChange={(v) => {
								setUsername(v);
								setUsernameError(false);
								setPasswordError(false);
								setError(false);
							}}
							error={usernameError}
							setError={setUsernameError}
							errorMessage={usernameErrorMjs}
						></ValidatedInput>

						<ValidatedPws
							className={styles.loginTextInput}
							label="Contraseña"
							placeholder="Escribe tu contraseña"
							onChange={(v) => {
								setPws(v);
								setUsernameError(false);
								setPasswordError(false);
								setError(false);
							}}
							error={passwordError}
							setError={setPasswordError}
							errorMessage={passwordErrorMjs}
						></ValidatedPws>

						<Switch
							className={styles.loginSwitch}
							label="Recordarme"
							onChange={setKeepLoggedIn}
						></Switch>

						<Typography
							color={error ? "red" : "transparent"}
							className={styles.loginErrorMjs}
						>
							Datos inválidos. Verifica e intenta nuevamente.
						</Typography>

						<div className={styles.loginReCaptchaContainer}>
							<div className={styles.loginReCaptcha}>
								<ReCAPTCHA
									sitekey={RECAPTCHA_KEY}
									hl="es"
									onChange={(token) => {
										setCaptchaError(false);
										setToken(token);
									}}
								></ReCAPTCHA>

								{captchaError && (
									<div className={styles.loginReCaptchaBorder}>
										<Typography
											className={styles.loginCaptchaError}
											variant="p2"
											color="red"
										>
											Debe realizar el reCAPTCHA
										</Typography>
									</div>
								)}
							</div>
						</div>

						<div onClick={() => navigate("/forgot-pws")}>
							<Typography className={styles.loginCardForgotPws}>
								¿Olvidaste tu contraseña?
							</Typography>
						</div>
					</div>
				</div>

				<Typography variant="p4" className={styles.loginRegisterLink}>
					¿Quieres ser Amigo Juan Valdez?{" "}
					<span
						className={styles.loginRegisterLinkSpan}
						onClick={() =>
							navigate("/register/validate-identity")
						}
					>
						Inscríbete aquí
					</span>
				</Typography>
			</AuthPageShell>

			{loader && <Loader />}
		</>
	);
};

export default Login;
